export const COUNTRY = {
  US: "US",
  CA: "CA",
  MX: "MX",
};

export const DUPAGE_LOCATION_CODE = "dupage";
export const INDIVIDUAL_USER_DEFAULT_CROSS_REFERENCE_NUMBER = "99500";
export const CMS_WARNING_MESSAGE_FOR_EXISTING_CASE = "Party and attorney information may not be current. It is still possible to E-File on list cases. Cases that have not been E-filed on previously will not be found at this time. (CMS Unavailable)";
